// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d05d7b8","455":"a781a9b6","488":"3289516e","977":"f9f3689e"}[chunkId] + ".chunk.js";
};